module.exports = __webpack_public_path__ + "img/yjdz.4d65aa2c.png";